module.exports = __webpack_public_path__ + "img/unbroken.ac82cd14.svg";